import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { getSegmentByDataModelId } from '../../../store/segment/api'
import { getDataModel } from '../../../store/model/api'
import ListPage from '../../Organisms/ListPage/ListPage'
import { ArchivePopup } from '../../Organisms/Popups/General/ArchivePopup'
import { SegmentListHeader } from './SegmentListHeader'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { handleError } from '../../../utils/handleErrors'
import { archiveEntityById } from '../../../store/general'
import { formatDate } from '../../../Services/dateFormat'
import editGreen from '../../../imgs/EditGreen.png'
import Delete from '../../../imgs/recycle.png'
import View from '../../../imgs/view.png'
import { FlowDetail } from '../FlowList/FlowDetail'

const type = 'segments'
export const SegmentList = () => {
    const [archivePopupId, setArchivePopupId] = useState(null)
    const [triggerRefresh, setTriggerRefresh] = useState(0)
    const [dataModel, setDataModel] = useState()
    const [dataModels, setDataModels] = useState([])
    const history = useHistory()

    useEffect(() => {
        getDataModel().then((_dataModels) => {
            setDataModels(_dataModels)
            const dataModelId = localStorage.getItem('dataModelId')
            setDataModel(dataModelId || _dataModels?.[0]?._id)
            setTriggerRefresh((v) => ++v)
        })
    }, [])
    const viewEntity = (item) => {
        history.push(`${window.location.pathname}/${item.data._id}?type=view`)
    }
    const deleteEntity = () => {
        archiveEntityById(archivePopupId, type)
            .then(() => {
                setArchivePopupId(null)
                setTriggerRefresh((v) => ++v)
                toast.success('Segment deleted successfully')
            })
            .catch(handleError)
    }

    const segmentTableColumn = [
        { headerName: 'Name', field: 'name', filter: true },
        { headerName: 'Data Model', field: 'dataModelName', filter: true },
        {
            field: 'createdAt',
            filter: true,
            sort: true,
            valueGetter: (params) => {
                return formatDate(new Date(params.data.createdAt))
            },
        },
        {
            headerName: 'Created By',
            field: 'user',
            filter: 'agDateColumnFilter',
        },
        {
            field: 'Actions',
            cellRenderer: (params) => {
                return (
                    <div className="icons">
                        <img
                            alt={'edit'}
                            src={editGreen}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            alt={'Delete'}
                            src={Delete}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                setArchivePopupId(params.data._id)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            src={View}
                            alt={'View'}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                viewEntity(params)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                    </div>
                )
            },
        },
    ]
    return (
        <>
            <ArchivePopup
                isOpen={!!archivePopupId}
                togglePanel={setArchivePopupId}
                onDelete={() => deleteEntity()}
            ></ArchivePopup>
            <div className={'tableWrapper'}>
                {dataModel ? (
                    <ListPage
                        title="Segment"
                        dataModelCall={getDataModel}
                        triggerCall={triggerRefresh}
                        dataCall={(_dataModels) =>
                            getSegmentByDataModelId(
                                { modelId: dataModel },
                                _dataModels,
                            )
                        }
                        tableColumns={segmentTableColumn}
                        parameterPanel={FlowDetail}
                        HeaderComponent={() => (
                            <SegmentListHeader
                                dataModel={dataModel}
                                setDataModel={(a) => {
                                    setDataModel(a)
                                    setTriggerRefresh((v) => ++v)
                                }}
                                dataModels={dataModels}
                            />
                        )}
                    />
                ) : null}
            </div>
        </>
    )
}
